export const fontSizes = {
	"xs": "14px", // 14px
	"sm": "16px", // 16px
	"md": "18px", // 18px
	"lg": "20px", // 20px
	"xl": "24px", // 24px
	"2xl": "28px", // 28px
	"3xl": "32px", // 32px
	"4xl": "40px", // 40px
	"5xl": "48px", // 48px
	"6xl": "56px", // 56px
};
